module.exports = __webpack_public_path__ + "public/img/banner.0eb62baf.png";